import { render, staticRenderFns } from "./mo-upload-wrapper.html?vue&type=template&id=897e788a&external"
import script from "./mo-upload-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-upload-wrapper.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-upload-wrapper.vue?vue&type=style&index=0&id=897e788a&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('897e788a')) {
      api.createRecord('897e788a', component.options)
    } else {
      api.reload('897e788a', component.options)
    }
    module.hot.accept("./mo-upload-wrapper.html?vue&type=template&id=897e788a&external", function () {
      api.rerender('897e788a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-upload-wrapper/mo-upload-wrapper.vue"
export default component.exports